/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Week_LastInputs */

const en_history_week_last = /** @type {(inputs: History_Week_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last week`)
};

const de_history_week_last = /** @type {(inputs: History_Week_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Woche`)
};

/**
* | output |
* | --- |
* | "Last week" |
*
* @param {History_Week_LastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_week_last = /** @type {((inputs?: History_Week_LastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Week_LastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_week_last(inputs)
	return en_history_week_last(inputs)
});